/**
 * Операционные capability в формате Django-permission (`app_label.codename`).
 * Зеркало серверного `FRONTEND_CAPABILITIES` (accounts/permissions.py).
 * Гейтим UI по этим строкам, а не по именам ролей — единый источник правды.
 */
export const CAPABILITIES = {
  MODERATE_CATALOG: 'accounts.moderate_catalog',
} as const;

export type Capability = (typeof CAPABILITIES)[keyof typeof CAPABILITIES];
